import { render, staticRenderFns } from "./RecommendedTagsPanel.vue?vue&type=template&id=304f654e&scoped=true"
import script from "./RecommendedTagsPanel.vue?vue&type=script&lang=js"
export * from "./RecommendedTagsPanel.vue?vue&type=script&lang=js"
import style0 from "./RecommendedTagsPanel.vue?vue&type=style&index=0&id=304f654e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304f654e",
  null
  
)

export default component.exports